import React from 'react';
import { xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { fg } from '@atlassian/jira-feature-gating';
import { type Props as TableCellProps, TableCell } from '../../table-cell/index.tsx';

export type LoadingCellProps = {
	cellBorder?: TableCellProps['border'];
	isColumnSticky?: boolean;
	stickyOffsets?: number;
	hasRightShadow?: boolean;
};

export const LoadingCell = ({
	cellBorder,
	isColumnSticky,
	stickyOffsets,
	hasRightShadow,
}: LoadingCellProps) => {
	const cellBorderStylesFg = fg('nin_issue_table_rtl_fix') ? cellBorderStyles : cellBorderStylesOld;
	return (
		<TableCell
			border={cellBorder ?? cellBorderStylesFg}
			isColumnSticky={isColumnSticky}
			stickyOffsets={stickyOffsets}
			hasRightShadow={hasRightShadow}
		>
			<Skeleton
				testId="native-issue-table.common.ui.issue-cells.loading-cell"
				height="16px"
				width="100%"
				borderRadius="3px"
			/>
		</TableCell>
	);
};

const cellBorderStylesOld = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
	borderTopWidth: '0',
	// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
	borderBottomWidth: 'border.width',
	// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
	borderLeftWidth: '0',
	// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
	borderRightWidth: 'border.width',
});

const cellBorderStyles = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderBlockStartWidth: '0',
	borderBlockEndWidth: 'border.width',
	borderInlineStartWidth: '0',
	borderInlineEndWidth: 'border.width',
});
